import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../components/Button";
import ModalConfirmacao from "../../components/Dialog";
import indisponivel from "../../assets/indisponivel.jpg";

import {
  Container,
  Header,
  ImovelCard,
  CardActions,
} from "./styles";

const DashboardImoveis = () => {
  const [imoveis, setImoveis] = useState([]);
  const [erro, setErro] = useState("");
  const [slugParaExcluir, setSlugParaExcluir] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
      fetch(`${process.env.REACT_APP_API_URL}/index.php?rota=imoveis`, {
        credentials: 'include'
      })
      .then((res) => res.json())
      .then((data) => {
        if (data.sucesso && Array.isArray(data.dados)) {
          setImoveis(data.dados);
        } else {
          setErro("Resposta inesperada da API");
          setImoveis([]);
        }
      })
      .catch(() => setErro("Erro ao carregar imóveis"));
  }, []);

  const excluirImovel = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/index.php?rota=imoveis&slug=${slugParaExcluir}`,
        {
          method: "DELETE",
          credentials: "include"
        }
      );
      if (res.ok) {
        setImoveis((prev) => prev.filter((i) => i.slug !== slugParaExcluir));
      } else {
        setErro("Erro ao excluir imóvel");
      }
    } catch {
      setErro("Erro de conexão com o servidor");
    } finally {
      setSlugParaExcluir(null);
    }
  };

  const getImagemPrincipal = (imagem) => {
    if (!imagem) return indisponivel;
    return `${process.env.REACT_APP_API_URL}/uploads/${imagem.split("uploads/")[1]}`;
  };


  return (
    <Container>
      <Header>
        <h2>Dashboard de Imóveis</h2>
        <Button onClick={() => {
          navigate("/dashboard/cadastrar")}}>
          Cadastrar novo imóvel
        </Button>
      </Header>

      {erro && <p style={{ color: "red" }}>{erro}</p>}

      <h3>Imóveis cadastrados</h3>
      {Array.isArray(imoveis) && imoveis.map((imovel) => (
        <ImovelCard key={imovel.slug}>
          <img
            src={getImagemPrincipal(imovel.imagem_principal)}
            alt={`Imagem do imóvel ${imovel.tipo}`}
            style={{ width: "100%", height: "auto", borderRadius: "8px", marginBottom: "10px" }}
          />

          <p><strong>{imovel.tipo}</strong> - {imovel.finalidade}</p>
          <p>{imovel.endereco}</p>
          <p>R$ {Number(imovel.valor).toLocaleString("pt-BR")}</p>
          <p>{imovel.status}</p>
          <CardActions>
            <Button onClick={() => navigate(`/dashboard/cadastrar?slug=${imovel.slug}`)}>Editar</Button>
            <Button onClick={() => setSlugParaExcluir(imovel.slug)}>Excluir</Button>
          </CardActions>
        </ImovelCard>
      ))}

      {slugParaExcluir && (
        <ModalConfirmacao
          texto="Deseja realmente excluir este imóvel?"
          onConfirmar={excluirImovel}
          onCancelar={() => setSlugParaExcluir(null)}
        />
      )}
    </Container>
  );
};

export default DashboardImoveis;